module.exports = __webpack_public_path__ + "static/media/0010_LES_MURS_CHROMATIC_CH2_1039.1e5420a2.webp";